export class ProvisionMainInfoModel {
    constructor() {
        this.Id = "";
        this.ProvisionType = 0;
        this.DocumentNumber = "";
        this.PatientName = "";
        this.District = "";
        this.ProvisionDate = "";
        this.PrescriptorFullName = "";
        this.StaffInitials = "";
        this.ProvisionState = 0;
        this.ReasonCode = "";
        this.Reporting = "";
        this.CustomerId = "";
    }
}